/**
 * Hooks index - Export all hooks for clean imports
 */

// API hooks
export * from './api';

// Page-specific hooks
export * from './useAboutPage';
export * from './useContactPage';
export * from './useNews';
export * from './useProducts';
export * from './useProjects';
export * from './useServices';
